
import { RequestLineItemModel } from './index';
export class RequestCheckoutModel {
  lineItems: RequestLineItemModel[];
  fan: string;
}
